import { ResponseStatus } from '@sdbn/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslationService } from '@sdbn/common';
import { Component, OnInit, Inject } from '@angular/core';
import { ResponseMessage } from '@sdbn/common';
import { SacClientService } from '../../../../service/sac-client.service';
import { SuspendStation } from '../../../../model/sac-client.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';

export class SuspendStationDialogData {
  stattionId: number;
}

@Component({
    selector: 'app-suspend-station-dialog',
    templateUrl: './suspend-station-dialog.component.html',
    styleUrls: ['./suspend-station-dialog.component.scss'],
    standalone: false
})
export class SuspendStationDialogComponent implements OnInit {

  isLoading = false;
  responseMessages: ResponseMessage[] = [];

  formGroup = new FormGroup({
    note: new FormControl('', [Validators.required, Validators.maxLength(255)]),
  });

  constructor(
    private sacClientService: SacClientService,
    public dialogRef: MatDialogRef<SuspendStationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SuspendStationDialogData,
    public translationService: TranslationService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
  }

  cancelDialog() {
    this.dialogRef.close();
  }

  public isSupendStationDisabled() {
    if (this.isLoading) {
      return true;
    }
    return this.formGroup.get('note')!.invalid;
  }

  public suspendStation() {
    this.isLoading = true;
    this.responseMessages = [];

    const suspension = new SuspendStation();
    suspension.stationId = this.data.stattionId;
    suspension.note = this.formGroup.get('note')!.value;
    this.sacClientService.suspendStation(suspension).subscribe(response => {
      this.isLoading = false;
      if (response.status === ResponseStatus.SUCCESS) {
        this.dialogRef.close();
      } else {
        this.responseMessages = response.responseMessages;
      }
    }, error => {
      this.isLoading = false;
      console.error('Error suspending station: ' + error);
    });
  }

}
